import { useState } from "react";
import {Flex,Avatar,Button,Space} from "antd";
import { UserOutlined, LeftOutlined, DoubleRightOutlined, DoubleLeftOutlined, HomeOutlined, FileTextOutlined, FolderOutlined, UserOutlined as UserIcon } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { getCurrentUserInfo } from '../../api/mockData'
import "./style.css";

/*header组件 */
const Header = ({index = 0}) =>{
    //有四个页面，HomePage,WritePage,ArchivePage,AuthPage
    const pages = [
        { name: 'HomePage', label: '主页', path: '/', icon: <HomeOutlined /> },
        { name: 'WritePage', label: '写作', path: '/write', icon: <FileTextOutlined /> },
        { name: 'ArchivePage', label: '归档', path: '/archive', icon: <FolderOutlined /> },
        { name: 'AuthPage', label: '我的', path: '/auth', icon: <UserIcon /> }
    ];
    
    //当前页面索引是否越界
    const isPageIndexValid = index >= 0 && index < pages.length;
    const currentPage = isPageIndexValid ? pages[index] : null;
    
    //弹出菜单状态
    const [menuVisible, setMenuVisible] = useState(false);
    const navigate = useNavigate();

    //切换页面函数
    const handleNavigate = (path) => {
        navigate(path);
    };

    //菜单开关函数
    const toggleMenu = () => {
        if (!isPageIndexValid) {
            // 页面索引无效时，点击按钮返回上一级
            navigate(-1);
        } else {
            // 页面索引有效时，切换菜单显示
            setMenuVisible(!menuVisible);
        }
    };

    //获取当前页面名称
    const getCurrentPageName = () => {
        // 当index<0时不显示任何内容
        return currentPage ? currentPage.label : '';
    };

    //确定左侧按钮的图标
    const getLeftButtonIcon = () => {
        if (!isPageIndexValid) {
            return <LeftOutlined />;
        }
        return menuVisible ? <DoubleLeftOutlined /> : <DoubleRightOutlined />;
    };
    const userInfo = getCurrentUserInfo();
    
    // 当用户是Tourist时，显示主页、归档和登录按钮
    const displayPages = userInfo.name === 'Tourist' 
        ? [...pages.filter(page => page.label === '主页' || page.label === '归档'), 
           { name: 'LoginPage', label: '登录', path: '/login', icon: <UserOutlined /> }]
        : pages;
    
    return (
        <>
            {/* Header 的布局 */}
            <Flex justify="space-between" align="center" className="header-container" style={{ height: '80px' }}>
                {/* 左侧部分 */}
                <Flex align="center">
                    {/* 左侧按钮 - 用于触发菜单 */}
                    <Button 
                        type="text" 
                        icon={getLeftButtonIcon()} 
                        onClick={toggleMenu}
                        className="header-left-button"
                        style={{ color: 'white', fontSize: '20px', marginLeft: '10px' }}
                    />
                    
                    {/* 弹出的页面切换按钮组 */}
                    <Space 
                        className={`header-menu-buttons ${menuVisible ? 'visible' : 'hidden'}`} 
                        style={{ marginLeft: '20px' }}
                    >
                        {displayPages.map((page, idx) => (
                            <Button 
                                key={idx}
                                type="text" 
                                icon={page.icon}
                                onClick={() => handleNavigate(page.path)}
                                style={{ color: 'white', fontSize: '16px' }}
                            >
                                {page.label}
                            </Button>
                        ))}
                    </Space>
                </Flex>
                
                {/* 中间页面名称 - 使用绝对定位居中，只有当页面索引有效时才显示 */}
                {isPageIndexValid && (
                    <div 
                        className={`header-page-title ${menuVisible ? 'hidden' : 'visible'}`}
                    >
                        {getCurrentPageName()}
                    </div>
                )}
                
                {/* 右边头像 */}
                <Avatar size="large" src={userInfo.avatar} className="header-avatar" style={{ marginRight: '20px' }} />
            </Flex>
        </>
    );

}

export default Header;